import { AbstractControl, FormGroup } from "@angular/forms";

const NO_EVENT = { emitEvent: false};

export abstract class AddressBehavior {
    private _form!: FormGroup;
    private _city!: AbstractControl;
    private _state!: AbstractControl;
    private _zipCode!: AbstractControl;

    public bindFormControls(
        form: FormGroup,
        city: AbstractControl,
        state: AbstractControl,
        zipCode: AbstractControl
    ) {
        this._form = form;
        this._city = city;
        this._state = state;
        this._zipCode = zipCode;

        this._city.valueChanges.subscribe(this._onCityChange.bind(this));
        this._state.valueChanges.subscribe(this._onStateChange.bind(this));
        this._zipCode.valueChanges.subscribe(this._onZipCodeChange.bind(this));
    }

    private _onCityChange(value: any) {
        if (!this._form.valid) { return; }

        this._state.setValue(null, NO_EVENT);
        this._state.markAsTouched();

        this._zipCode.setValue(null, NO_EVENT);
        this._zipCode.markAsTouched();

        this._form.updateValueAndValidity();
    }

    private _onStateChange(value: any) {
        if (!this._form.valid) { return; }

        this._city.setValue(null, NO_EVENT);
        this._city.markAsTouched();

        this._zipCode.setValue(null, NO_EVENT);
        this._zipCode.markAsTouched();

        this._form.updateValueAndValidity();
    }

    private _onZipCodeChange(value: any) {
        if (!this._form.valid) { return; }

        this._state.setValue(null, NO_EVENT);
        this._state.markAsTouched();
        
        this._city.setValue(null, NO_EVENT);
        this._city.markAsTouched();

        this._form.updateValueAndValidity();
    }
}